<template>
  <modal v-bind="[$props, $attrs]" size="md" @modal-close="emitClose">
    <h4 slot="header" class="title">{{ info.name }}</h4>
    <div class="features-wrapper">
      <div v-for="(feature, index) in tariffFeatures"
           :key="'feature'+index"
           class="feature">
        <img :src="feature.icon" class="icon" alt=""/>
        <div class="description-wrap">
          <p v-for="(singleFeature, idx) in feature.data"
             :key="'single'+idx"
             class="description">{{ singleFeature.description }} <span>{{ singleFeature.name }}</span></p>
        </div>
      </div>
    </div>
    <div class="tariff-footer">
      <p class="price" v-if="info.price">{{ info.price.formattedValue }} <span>{{ $t('changeTariff.currency') }}</span></p>
      <base-button v-if="!info.currentTariff"
                   variant="primary"
                   :disabled="!info.canChange || isPending"
                   class="change-tariff-btn"
                   @click="emitChangeEvent">{{ $t('changeTariff.changeTariffLabel') }}
      </base-button>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/common/modal/modal'

export default {
  name: 'tariff-info-modal',
  inheritAttrs: false,
  data () {
    return {
      tariffFeatures: []
    }
  },
  props: {
    tariffInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isPending: {
      type: Boolean
    }
  },
  components: { Modal },
  computed: {
    info () {
      // dodato da ne bih stalno kucao u templejtu $props.tariffInfo...
      // nema potrebe da ovo bude reaktivno, tako da možemo slobodno freeze
      return Object.freeze(this.$props.tariffInfo)
    }
  },
  methods: {
    emitClose () {
      this.$emit('close')
    },
    /**
     * According to design, data needs to be grouped by unitOfMeasurmentId, so there's only one icon for those
     * @param data {Object} this is the same data we get in tariffInfo prop
     * @returns {[]|*[]} returns array of objects we can use to loop through in template
     */
    getSimilarBenefitsObject (data = {}) {
      if (!Object.keys(data).length) return []
      else if (!data.productSpecCharacteristicValues || !data.productSpecCharacteristicValues.length) return []
      const features = []
      data.productSpecCharacteristicValues.forEach(feature => {
        if (features.some(f => f.unit === feature.unitOfMeasurmentId)) {
          features.forEach(f => {
            if (f.unit === feature.unitOfMeasurmentId) {
              f.data.push({
                name: feature.characteristicName,
                description: feature.description
              })
            }
          })
        } else {
          features.push({
            icon: feature.icon.url,
            unit: feature.unitOfMeasurmentId,
            data: [{
              name: feature.characteristicName,
              description: feature.description
            }]
          })
        }
      })

      return features
    },
    emitChangeEvent () {
      this.$emit('change-tariff')
    }
  },
  watch: {
    /**
     * Triggers repacking of the object when tariffInfo data in prop changes
     * @param newVal {Object}
     */
    tariffInfo (newVal) {
      this.tariffFeatures = [...this.getSimilarBenefitsObject(newVal)]
    }
  }
}
</script>

<style scoped lang="scss">
.title {
  font-size: 3.2rem;
  margin-top: -2.6rem;
}

.features-wrapper {
  display: flex;
  flex-direction: column;
  padding: 0.8rem;

  .feature {
    display: flex;
    margin-bottom: 0.8rem;

    img.icon {
      height: 32px;
      width: auto;
      margin-right: 2.4rem;
      display: block;
    }

    .description-wrap {
      display: flex;
      flex-wrap: wrap;
      flex: 1 1 auto;
    }

    .description {
      font-size: 1.6rem;
      font-weight: 600;
      line-height: 1.25;
      margin: 0.4rem 3.2rem 1.2rem 0;

      span {
        font-weight: normal;
        color: $dark-grey;
        display: block;
      }
    }
  }
}

.tariff-footer {
  margin: 0 -3.2rem -1.6rem;
  width: calc(100% + 6.4rem);
  padding: 2.4rem 4rem 0;
  border-top: 1px solid $grey;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (map_get($breakpoints, sm)) {
    flex-direction: row;
    justify-content: space-between;
  }

  .price {
    font-size: 3.2rem;
    font-weight: 600;
    color: $primary;

    span {
      font-size: 1.6rem;
      color: $text;
    }
  }

  .change-tariff-btn {
    width: 100%;
    margin-top: 2.4rem;

    @media (map_get($breakpoints, sm)) {
      width: auto;
      margin-top: 0;
    }
  }
}
</style>
